/* eslint-disable import/prefer-default-export */
import { reportSdkFlow } from './reportSdkFlow';
const color = ['green', 'blue', 'red'];
let i = 0;

export function createLog(type: string) {
  const index = i % 3;
  i += 1;
  return function log(...args: any[]) {
    console.log(`%c ${type}: %s`, `color:${color[index]}`, ...args);
    reportSdkFlow({
      api_method: `Log.${type}`,
      api_param: args
        .map((a) => {
          const t = typeof a;
          if (t === 'string' || t === 'number' || t === 'boolean') {
            return a;
          }
          try {
            return JSON.stringify(a);
          } catch (e) {
            return a;
          }
        })
        .join(' '),
      api_code: 0,
      api_type: 'console',
    });
  };
}
